import { render, staticRenderFns } from "./SidebarInfoProgress.vue?vue&type=template&id=23173de6"
import script from "./SidebarInfoProgress.vue?vue&type=script&lang=js"
export * from "./SidebarInfoProgress.vue?vue&type=script&lang=js"
import style0 from "./SidebarInfoProgress.vue?vue&type=style&index=0&id=23173de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports